/**
 * @file
 *
 * Initializes legacy jQuery UI accordions and tabs in frontend content.
 */

$(document).ready(function(){
	$('.accordion:not(.advanced-accordion)').each(function(){
		var cur = $(this);
		
		cur.accordion({
			collapsible: true,
			active: cur.is('.closed') === false ? 0 : false,
			heightStyle: 'content'
		});
		
		if (cur.is('.open-multiple')) {
			cur.on('accordionbeforeactivate', function(event, ui) {
				if (ui.newHeader[0]) {
					var currHeader  = ui.newHeader;
					var currContent = currHeader.next('.ui-accordion-content');
				} else {
					var currHeader  = ui.oldHeader;
					var currContent = currHeader.next('.ui-accordion-content');
				}

				var isPanelSelected = currHeader.attr('aria-selected') == 'true';

				currHeader.toggleClass('ui-corner-all',isPanelSelected).toggleClass('accordion-header-active ui-state-active ui-corner-top',!isPanelSelected).attr('aria-selected',((!isPanelSelected).toString()));
				currHeader.children('.ui-icon').toggleClass('ui-icon-triangle-1-e',isPanelSelected).toggleClass('ui-icon-triangle-1-s',!isPanelSelected);
				currContent.toggleClass('accordion-content-active',!isPanelSelected);

				if (isPanelSelected) {
					currContent.slideUp();
				} else {
					currContent.slideDown();
				}

				return false;
			});
		}
	});
	
	$('.tabs').tabs();
});
